import { render } from "./FraudNotice.vue?vue&type=template&id=0367e5d4&scoped=true"
import script from "./FraudNotice.vue?vue&type=script&lang=js"
export * from "./FraudNotice.vue?vue&type=script&lang=js"

import "./FraudNotice.vue?vue&type=style&index=0&id=0367e5d4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\kevin.chang\\Documents\\hzn\\oversea-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0367e5d4"]])

export default __exports__